
import { Box, Center, Spinner } from "@chakra-ui/react";
import React from "react";

const Loader2 = ({bg}) => {
  return (
    <Center 
      h="100vh" 
      position="fixed" 
      top={0} 
      left={0} 
      right={0} 
      bottom={0}
      bg="rgba(0, 0, 0, 0.3)"
      backdropFilter="blur(4px)"
      zIndex={9999}
    >
      <Box
        bg="white"
        borderRadius="16px"
        p={10}
        boxShadow="0 20px 60px rgba(0, 0, 0, 0.15)"
        textAlign="center"
      >
        <Spinner
          thickness="5px"
          speed="0.65s"
          emptyColor="gray.200"
          color="#e0a604"
          size="xl"
          // mb={4}
        />
        <Box fontSize="sm" color="gray.600" fontWeight="500" mt={4}>
          Loading...
        </Box>
      </Box>
    </Center>
  );
};

export default Loader2;
